<template>
  <div>

    <v-container>
      <v-card class="mx-auto my-5" max-width="4000" style="max-width:4000px !important">
        <v-system-bar dark>
          <v-flex>
            <center>CONSULTAR ESTADO</center>
          </v-flex>
        </v-system-bar>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row class="mt-4 container align-baseline">
            <v-col cols="3" sm="3" md="3">
              <!-- <v-text-field
              max-width="200"
              class="mx-3"
              v-model="searchDNI"
              label="Buscar por documento"
              prepend-inner-icon="mdi-magnify"
              variant="outlined"
              hide-details
              single-line :maxlength="8"
            ></v-text-field> -->
              <v-autocomplete v-model="searchDNI" :items="filteredData" item-text="dni" item-value="dni"
                id="inputDocumento" dense label="DOCUMENTO"></v-autocomplete>
            </v-col>
            <v-col cols="3" sm="3" md="3">
              <v-autocomplete v-model="searchPaciente" :items="filteredData" item-text="pacienteNombre"
                item-value="pacienteNombre" id="inputPaciente" dense label="PACIENTE"></v-autocomplete>
            </v-col>
            <v-col cols="3" sm="3" md="3">
              <v-autocomplete v-model="searchClinica" :items="filteredData" item-text="clinica" item-value="clinica"
                id="inputClinica" dense label="CLÍNICA"></v-autocomplete>

            </v-col>
            <!-- BOTON DE AGREGAR SOLICITUD-->
            <v-col cols="3" sm="3" md="3">
              <v-btn color="#1973a5" dark class="mb-2" @click="dialog = true" style="margin:0 1rem">
                {{ actionBoton }}
              </v-btn>
              <v-btn color="#1973a5" dark class="mb-2" @click="dialogAsignarCupo = true">
                Asignar Cupo
              </v-btn>
              <v-btn color="green" dark class="mb-2" @click="exportToExcel">
                Exportar
              </v-btn>
              <v-btn color="green" dark class="mb-2" @click="exportToExcelTo" style="margin-left: 1rem;">
                Cambio ipress
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
      <br>
      <!-- TABLA RESULTADO-->
      <v-card class="mb-4">
        <v-tabs v-model="tab" background-color="#1973a5" @change="cambioTab" center-active dark>
          <!--  <v-tab value="pendientes">EN PROCESO</v-tab> -->
          <v-tab value="liberados">LIBERADOS</v-tab>
          <v-tab value="ocupados">OCUPADOS</v-tab>
          <!-- OBSERVADOS Y TERMINADOS -->
        </v-tabs>
      </v-card>
      <v-card>
        <v-data-table :headers="headers" :items="filteredData" class="elevation-1">
        </v-data-table>
      </v-card>
    </v-container>
    <v-dialog v-model="dialogLoad" hide-overlay persistent width="300" class="fondo-griss">
      <v-card color="primary" dark>
        <v-card-text>
          Cargando Datos
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" v-if="dialog" max-width="800px" persistent>
      <LiberarCupo @closeDialog="closeDialog" />
    </v-dialog>
    <v-dialog v-if="dialogAsignarCupo" v-model="dialogAsignarCupo" max-width="600px" persistent>
      <AsignarCupo @closeDialogAsignarCupo="closeDialogAsignarCupo" />
    </v-dialog>
  </div>
</template>
<style scoped>
::v-deep.theme--dark.v-system-bar {
  background: linear-gradient(135deg, rgb(25 115 165), rgb(20 145 215), #0d67aa, #00304e) !important;
}

.table-container {
  overflow-x: auto;
}

.sticky-col {
  position: sticky;
  background-color: white;
  z-index: 10;
}

.sticky-col.left {
  left: 0;
}

.sticky-col.right {
  right: 0;
}

.v-toolbar {
  background: linear-gradient(135deg, rgb(25, 115, 165), rgb(20, 145, 215), #0d67aa, #00304e);
  color: white !important;
}

.v-card-title {
  text-align: center;
}
</style>
<script>
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import LiberarCupo from "./liberar_cupo.vue";
import AsignarCupo from "./asignar_cupo.vue";
import axios from "axios";

export default {
  data: () => ({
    tab: 0,
    dialogLoad: true,
    searchDNI: null,
    searchPaciente: null,
    searchClinica: null,
    actionBoton: "LIBERAR CUPO",
    editedItem: {
      //Cupos
      paciente: "",
      frecuencia: "",
      turno: "",
      nombrePaciente: "",
      correo: "",
    },
    headers: [
      {
        text: "Frecuencia",
        value: "frecuencia",
      },
      {
        text: "Turno",
        value: "turno",
      },
      {
        text: "Clínica",
        value: "clinica",
      },
      {
        text: "DNI",
        value: "dni",
      },
      {
        text: "Paciente",
        value: "pacienteNombre",
      },
      {
        text: "Serología",
        value: "serologia",
      },
      {
        text: "Fecha",
        value: "fecha",
      },
      {
        text: "Usuario",
        value: "usuario",
      },
    ],
    desserts: [],
    dialog: false,
    valid: true,
    itemsDatosPaciente: [],
    itemsTurno: [],
    itemsTipoSolcitud: [],
    nombrePaciente: "",
    estadoTab: "ATENDIDO",
    dialogAsignarCupo: false
  }),
  methods: {
    closeDialogAsignarCupo() {
      this.dialogAsignarCupo = false;
    },
    closeDialog() {
      this.dialog = false;
      this.liberados();
    },
    exportToExcel() {
      // Datos que deseas exportar
      const XLSXStyle = require("xlsx-js-style");

      // Definir cabecera
      const headers = [
        "N°", "Fecha", "IPRESS", "Apellidos y nombres",
        "DNI/CE", "Fecha de última dialísis", "Serología", "Frecuencia",
        "Secuencia", "Turno", "Motivo", "Adjunto"
      ];
      // Convertir datos a formato adecuado para la hoja de cálculo
      const datos = this.filteredData;
      const rows = datos.map((item, index) => [
        index + 1, item.fecha, item.clinica, item.pacienteNombre,
        item.dni, item.fecha, item.serologia, item.frecuencia,
        item.frecuencia, item.turno, item.turno, item.tipoPuesto
      ]);

      // Combinar cabecera y datos
      const worksheetData = [headers, ...rows];

      // Crear una hoja de cálculo
      const worksheet = XLSXStyle.utils.aoa_to_sheet(worksheetData);
      const workbook = XLSXStyle.utils.book_new();
      XLSXStyle.utils.book_append_sheet(workbook, worksheet, 'Pacientes');

      // Exportar a archivo Excel
      XLSXStyle.writeFile(workbook, 'pacientes.xlsx');
    },
    exportToExcelTo() {
      // Datos que deseas exportar
      const XLSXStyle = require("xlsx-js-style");

      // Definir cabecera
      const headers = [
        "N°", "Hospital de origen", "Fecha de solicitud", "Fecha de cambio",
        "Apellidos y nombres", "DNI/CE", "Ipress de origen", "Fecha de diálisis (FUD) en IPRESS de origen", "Serología",
        "Secuencia IPRESS origen", "Turno IPRESS origen", "IPRESS destino", "Fecha de inicio de diálisis (FID) en IPRESS destino", "Secuencia IPRESS destino", "Turno IPRESS destino", "Motivo", "Condición"
      ];
      // Convertir datos a formato adecuado para la hoja de cálculo
      const datos = this.filteredData;
      const rows = datos.map((item, index) => [
        index + 1, item.fecha, item.clinica, item.pacienteNombre,
        item.dni, item.fecha, item.serologia, item.frecuencia,
        item.frecuencia, item.turno, item.turno, item.tipoPuesto
      ]);

      // Combinar cabecera y datos
      const worksheetData = [headers, ...rows];

      // Crear una hoja de cálculo
      const worksheet = XLSXStyle.utils.aoa_to_sheet(worksheetData);
      const workbook = XLSXStyle.utils.book_new();
      XLSXStyle.utils.book_append_sheet(workbook, worksheet, 'Pacientes');

      // Exportar a archivo Excel
      XLSXStyle.writeFile(workbook, 'pacientes.xlsx');
    },
    cambioTab() {
      if (this.tab == 0) {
        this.desserts = [];
        this.estadoTab = "PENDIENTE";
        this.liberados();
      } else if (this.tab == 1) {
        this.desserts = [];
        this.estadoTab = "ATENDIDO";
        this.ocupados();
      }
    },
    liberados() {
      this.dialogLoad = true;
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(
              RUTA_API +
              "/rep_cupos/?", { clinica_id: null, estado: false },
              {
                headers: { Authorization: this.auth },
              }
            )
            .then((res) => {

              this.desserts = res.data;
              this.dialogLoad = false;
            })
            .catch((res) => {
              console.log("SSSSS", res.data);
              this.dialogLoad = false;
            });
        });
    },
    ocupados() {
      this.dialogLoad = true;
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(
              RUTA_API +
              "/rep_cupos/?", { clinica_id: null, estado: true },
              {
                headers: { Authorization: this.auth },
              }
            )
            .then((res) => {
              this.desserts = res.data;
              this.dialogLoad = false;
            })
            .catch((res) => {
              console.log("SSSSS", res.data);
              this.dialogLoad = false;
            });
        });
    },
    comboTipoSolicitud() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(RUTA_API + "/maestro/?search=TS001", {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              for (let i = 0; i < res.data.length; i++) {
                this.itemsTipoSolcitud.push(res.data[i].descripMaestro);
              }
            })
            .catch((res) => {
              console.log(res.data);
            });
        })
        .catch((response) => {
          console.log(response.data);
        });
    },
    comboTurnos() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(RUTA_API + "/maestro/?search=TR001", {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              for (let i = 0; i < res.data.length; i++) {
                this.itemsTurno.push(res.data[i].descripMaestro);
              }
            })
            .catch((res) => {
              console.log(res.data);
            });
        })
        .catch((response) => {
          console.log(response.data);
        });
    },
    close() {
      this.dialog = false;
      this.editedItem.paciente = "";
      this.editedItem.tipoSolicitud = "";
      this.editedItem.turno = "";
      this.editedItem.correo = "";
    },
  },
  computed: {
    filteredData() {
      if (!this.searchDNI && !this.searchPaciente && !this.searchClinica) {
        return this.desserts;
      }
      let filtered = this.desserts;
      if (this.searchDNI) {
        filtered = filtered.filter(item => item.dni.toLowerCase().includes(this.searchDNI.toLowerCase()));
      }
      if (this.searchPaciente) {
        filtered = filtered.filter(item => item.pacienteNombre.toLowerCase().includes(this.searchPaciente.toLowerCase()));
      }
      if (this.searchClinica) {
        filtered = filtered.filter(item => item.clinica.toLowerCase().includes(this.searchClinica.toLowerCase()));
      }
      return filtered;
    },
  },
  mounted() {
    if (!sessionStorage.getItem("keyValue")) {
      this.$router.push("/");
    }
    const inputDocumento = document.getElementById("inputDocumento");
    inputDocumento.addEventListener("input", (event) => {
      const valor = event.target.value;
      /* this.searchDNI=valor; */
    });

    const inputPaciente = document.getElementById("inputPaciente");
    inputPaciente.addEventListener("input", (event) => {
      const valor = event.target.value;

    });
  },
  created() {
    this.perfil = sessionStorage.getItem("perfil");
    this.nombre = sessionStorage.getItem("nombre");
    this.url = sessionStorage.getItem("url");
    this.usuario = sessionStorage.getItem("usuario");
    this.urlCas = sessionStorage.getItem("urlCas");
    //INICIO DE CONSULTA
    this.comboTipoSolicitud();
    this.comboTurnos();
    this.liberados();
  },
  components: {
    LiberarCupo,
    AsignarCupo
  },
};
</script>
